import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"align":"center","jusitfy":"center"}},[_c(VContainer,{staticClass:"iframe-wrapper"},[_c('div',{staticClass:"iframe-container"},[_c('iframe',{attrs:{"allow":"camera; microphone","id":"kioskApp","src":"https://stanislaus-kiosk.arsconnect.com/","frameborder":"1px"}}),_c('span',[_vm._v(_vm._s(_vm.innWidth))])])]),_c(VBtn,{attrs:{"color":"error"},on:{"click":function($event){return _vm.logout()}}},[_vm._v("Click to Reload the Kiosk App")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }